
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

class Menu {

    constructor() {

        this.$elem = $('[data-menu]');

        if ( !this.$elem.length )
            return;

        this.$toggler = $('[data-menu-toggle]');
        this.$headerMain = $('[data-header-main]');

        if ( !this.$toggler.length || !this.$headerMain.length )
            return;

        this.active = this.$elem.hasClass('is-active');
        this.$toggler.on( 'click', this.scroll.bind(this) );

    }

    toggle() {

        this.active = !this.active;
        this.$elem.toggleClass( 'is-active' );
        this.$toggler.toggleClass( 'is-active' );

        if ( this.active ) {
            disableBodyScroll( this.$elem[0] );
        } else {
            enableBodyScroll( this.$elem[0] );
        }

    }

    toggleChildren( e ) {

        let $existing = $('.is-expanded');
        let $existingChildren = $existing.siblings('[data-menu-children]');
        
        let $parent = $(e.currentTarget);
        let $children = $parent.siblings('[data-menu-children]');

        $parent.toggleClass('is-expanded');
        $children.slideToggle( 200 );

        if ($('.is-expanded').length > 1) {
            $existing.toggleClass('is-expanded');
            $existingChildren.slideToggle( 200 );
        }

    }

    scroll() {

        if ( $(window).width() > 768 ) {

            $('html, body').scrollTop( this.$headerMain.offset().top + 2 );
            // $('html, body').animate({
            //     scrollTop: this.$headerMain.offset().top + 2
            // }, 500 );

        }

        this.toggle();

    }

}

new Menu();
